import { Paragraph, Separator, View } from 'tamagui'
import { mesaColorNames } from '@/src/common/theme'
import { formatCurrency } from '@/src/common/utils/general'
import { Button } from '@/src/common/components/Button'
import { router } from 'expo-router'
import * as Navigation from '../navigation'
import { E2E } from '..'

export function MortgageUploadRejected({
  activeAmount,
  requestedAmount,
}: {
  requestedAmount: string
  activeAmount: string | undefined
}) {
  return (
    <>
      <Paragraph color={mesaColorNames['semantic/fg/error #DB340B']} shrink={1}>
        Your request to update your monthly payment amount to{' '}
        {formatCurrency(requestedAmount, { decimals: 0 })} was rejected because your mortgage
        statement upload was not accepted.{' '}
        {activeAmount
          ? `Your active monthly payment amount has returned to ${formatCurrency(activeAmount, { decimals: 0 })}.`
          : 'You will not receive any rewards until your mortgage statement is accepted.'}
      </Paragraph>
      <Separator />
      <Paragraph color={mesaColorNames['semantic/fg/error #DB340B']} shrink={1}>
        Mortgage statements MUST include owner name, property address, loan details, and standard
        monthly payment.
      </Paragraph>
      <Paragraph color={mesaColorNames['semantic/fg/error #DB340B']} shrink={1}>
        Documents missing these items will be rejected.
      </Paragraph>
      <Paragraph color={mesaColorNames['semantic/fg/error #DB340B']} shrink={1}>
        Documents that are altered in any way, including blacking out areas or other alterations,
        will be rejected and may lead to removal from the program.
      </Paragraph>
      <Separator />
      <Paragraph>
        To verify your rewards, you must provide a recent mortgage statement (last 60 days) from
        your bank or lender.
      </Paragraph>
      <View mt={16}>
        <Button
          title="Continue to Upload"
          onPress={() => router.push(Navigation.Routes.MortgageEarnDocumentUpload.route)}
          testID={E2E.Config.Ids.Press.ContinueToUpload}
        />
      </View>
    </>
  )
}
